<template>
    <div class="relative p-[20] rate-box">
        <img v-if="getCityAssetsFile('rate-bg.png')" class="absolute top-[0] left-[0]" width="100%" :src="getCityAssetsFile('rate-bg.png')"
            alt="">
        <div class="t-[#303133] t-[16] leading-[22]">对我们的服务还满意吗？快来给个好评吧～</div>
        <div class="mt-[16] rate-form p-[16] relative">
            <div class="flex items-center h-[32]" @mouseleave="mouseleave">
                <span class="t-[#303133] t-[14] mr-[16]">综合评价</span>
                <img @mouseenter="changeRate(1, 'overallScore', 'mouseenter')"
                    @click="changeRate(1, 'overallScore', 'click')" v-if="rateForm.overallScore == 1"
                    class="w-[32] h-[32] mr-[16] cursor-pointer" :src="getAssetsFile('rate/rate_01.png')" alt="">
                <img @mouseenter="changeRate(1, 'overallScore', 'mouseenter')"
                    @click="changeRate(1, 'overallScore', 'click')" v-else class="w-[32] h-[32] mr-[16] cursor-pointer"
                    :src="getAssetsFile('rate/rate_1.png')" alt="">
                <img @mouseenter="changeRate(2, 'overallScore', 'mouseenter')"
                    @click="changeRate(2, 'overallScore', 'click')" v-if="rateForm.overallScore == 2"
                    class="w-[32] h-[32] mr-[16] cursor-pointer" :src="getAssetsFile('rate/rate_02.png')" alt="">
                <img @mouseenter="changeRate(2, 'overallScore', 'mouseenter')"
                    @click="changeRate(2, 'overallScore', 'click')" v-else class="w-[32] h-[32] mr-[16] cursor-pointer"
                    :src="getAssetsFile('rate/rate_2.png')" alt="">
                <img @mouseenter="changeRate(3, 'overallScore', 'mouseenter')"
                    @click="changeRate(3, 'overallScore', 'click')" v-if="rateForm.overallScore == 3"
                    class="w-[32] h-[32] mr-[16] cursor-pointer" :src="getAssetsFile('rate/rate_03.png')" alt="">
                <img @mouseenter="changeRate(3, 'overallScore', 'mouseenter')"
                    @click="changeRate(3, 'overallScore', 'click')" v-else class="w-[32] h-[32] mr-[16] cursor-pointer"
                    :src="getAssetsFile('rate/rate_3.png')" alt="">
                <img @mouseenter="changeRate(4, 'overallScore', 'mouseenter')"
                    @click="changeRate(4, 'overallScore', 'click')" v-if="rateForm.overallScore == 4"
                    class="w-[32] h-[32] mr-[16] cursor-pointer" :src="getAssetsFile('rate/rate_04.png')" alt="">
                <img @mouseenter="changeRate(4, 'overallScore', 'mouseenter')"
                    @click="changeRate(4, 'overallScore', 'click')" v-else class="w-[32] h-[32] mr-[16] cursor-pointer"
                    :src="getAssetsFile('rate/rate_4.png')" alt="">
                <img @mouseenter="changeRate(5, 'overallScore', 'mouseenter')"
                    @click="changeRate(5, 'overallScore', 'click')" v-if="rateForm.overallScore == 5"
                    class="w-[32] h-[32] mr-[16] cursor-pointer" :src="getAssetsFile('rate/rate_05.png')" alt="">
                <img @mouseenter="changeRate(5, 'overallScore', 'mouseenter')"
                    @click="changeRate(5, 'overallScore', 'click')" v-else class="w-[32] h-[32] mr-[16] cursor-pointer"
                    :src="getAssetsFile('rate/rate_5.png')" alt="">
                <span class="t-[14] t-[#606266]">{{ rateType[rateForm.overallScore] }}</span>
            </div>

            <div class="mt-[16] p-[16] bg-[#fff]" v-if="overallScore != 0">
                <div class="flex items-center">
                    <div class=" flex items-center h-[32] shrink-0 w-[320]">
                        <span class="mr-[12]">出函时间</span>
                        <el-rate v-model="rateForm.insureTimeScore" show-text :texts="texts"
                            @change="changeScore($event, 'insureTimeScore', 'change')"></el-rate>
                        <!-- <div class="t-[14] t-[#606266] ml-[12]">{{ rateType[rateForm.insureTimeScore] }}</div> -->
                    </div>
                    <div class=" flex items-center h-[32] shrink-0 w-[320]">
                        <span class="mr-[12]">收费合理</span>
                        <el-rate v-model="rateForm.affordableScore" show-text :texts="texts"
                            @change="changeScore($event, 'affordableScore', 'change')"></el-rate>
                        <!-- <div class="t-[14] t-[#606266] ml-[12]">{{ rateType[rateForm.affordableScore] }}</div> -->
                    </div>
                    <div class=" flex items-center h-[32] shrink-0 w-[320]">
                        <span class="mr-[12]">服务态度</span>
                        <el-rate v-model="rateForm.serviceAttitudeScore" show-text :texts="texts"
                            @change="changeScore($event, 'serviceAttitudeScore', 'change')"></el-rate>
                        <!-- <div class="t-[14] t-[#606266] ml-[12]">{{ rateType[rateForm.serviceAttitudeScore] }}</div> -->
                    </div>
                </div>
                <div class="flex items-center">
                    <div class=" flex items-center h-[32] shrink-0 w-[320]">
                        <span class="mr-[12]">审核时效</span>
                        <el-rate v-model="rateForm.auditTimeScore" show-text :texts="texts"
                            @change="changeScore($event, 'auditTimeScore', 'change')"></el-rate>
                        <!-- <div class="t-[14] t-[#606266] ml-[12]">{{ rateType[rateForm.auditTimeScore] }}</div> -->
                    </div>
                    <div class="flex items-center h-[32] shrink-0 w-[320]">
                        <span class="mr-[12]">产品合规</span>
                        <el-rate v-model="rateForm.productComplianceScore" show-text :texts="texts"
                            @change="changeScore($event, 'productComplianceScore', 'change')"></el-rate>
                        <!-- <div class="t-[14] t-[#606266] ml-[12]">{{ rateType[rateForm.productComplianceScore] }}</div> -->
                    </div>
                </div>
            </div>

            <div class="mt-[16] bg-[#fff]">
                <el-input v-model="rateForm.content" type="textarea" placeholder="写几句话对这次服务做个评价吧～" :rows="4"
                    maxlength="200" show-word-limit resize="none" class="w-[100%]"></el-input>
            </div>
            <div class="mt-[16] text-right">
                <el-button class="w-[120]" size="mini" type="primary" @click="handleSubmitRate">提交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    mixins: [mixin],
    name: 'dg-rate',
    data() {
        return {
            overallScore: 0,
            rateType: { 1: '非常差', 2: '差', 3: '一般', 4: '满意', 5: '非常满意' },
            texts: ['非常差', '差', '一般', '满意', '非常满意'],
            rateName: { 'affordableScore': '', 'auditTimeScore': '', 'insureTimeScore': '', 'productComplianceScore': '', 'serviceAttitudeScore': '' },
            rateForm: {
                affordableScore: 0,  // 收费合理评分 
                auditTimeScore: 0,  // 审核时效评分 
                guaranteeCategoryCode: "",  // 保函品种 
                insureTimeScore: 0,  // 出函时效评分 
                overallScore: 0,  // 综合评分 
                productComplianceScore: 0,  // 产品合规评分 
                serviceAttitudeScore: 0,  // 服务态度评分 
                content: "",  // 评价内容 
                taction: this.$route.query.taction,  // 订单业务动作 
                tradeNo: this.$route.query.tradeNo,  // 订单号                 
                token: this.$route.query.token,  // token 
                tv: this.$route.query.tv,  // token版本号 
                udp: this.$route.query.udp,  // 用户所处的设备端 
            },
        }
    },
    props: {
        value: {
            type: [Number, String],
        },
        bgColor: {
            type: String,
            default: '#FF9900'
        },
        guaranteeCategoryCode: {
            type: [String, Number],
            default: ''
        }
    },
    watch: {
        guaranteeCategoryCode: {
            deep: true,
            immediate: true,
            handler(newVal) {
                // console.log(newVal,'new')
                this.rateForm.guaranteeCategoryCode = newVal
            },
        },
    },
    methods: {

        handleSubmitRate() {
            if (this.rateForm.overallScore == 0) {
                Mirror.emit(['tips_bus'], "请先评分后再提交");
                return;
            }
            ajax.post({
                url: '/customer/financialInstitutionEvaluate/external/submit',
                data: this.rateForm,
                success: (res) => {
                    if (res) {
                        Mirror.emit('tips_bus', {
                            msg: "提交成功",
                            type: "success",
                        });
                        setInterval(() => {
                            this.$emit('changeData')
                        }, 2000);
                    }
                },
            })
        },
        changeScore(score, name) {
            this.rateName[name] = score
            this.rateForm[name] = score
        },
        changeRate(overallScore, name, type) {
            // if (this.overallScore == 0) {

            // }
            if (type == 'click') {
                this.overallScore = overallScore
                for (let key in this.rateName) {
                    if (!this.rateName[key]) {
                        this.rateForm[key] = overallScore
                    }
                }
            }
            this.rateForm[name] = overallScore

        },
        mouseleave() {
            this.rateForm.overallScore = this.overallScore
        }
    }
}
</script>
<style scoped lang="less">
// @import '~@/assets/css/var.less';
.rate-box {
    overflow: hidden;
    background-color: #FFF7F7;
    border: 1px solid #ffffff;

    /deep/ .el-textarea__inner {
        background-color: #FFFFFF;
        border: 1px solid #E4E7ED;
    }
}

.rate-form {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #FFFFFF;
    z-index: 99;
}

.aui-gap {
    gap: 0 5px;
    position: relative;
}
</style>